import {
  YesNoFormValue,
  type KilnCheckSheetAdditionalCommentsSectionFormValues
} from '../../../types'

export const additionalCommentsSectionDefaultValues: KilnCheckSheetAdditionalCommentsSectionFormValues =
  {
    checkLinesForOilLeaksOrSpills: YesNoFormValue.YES,
    checkLinesForOilLeaksOrSpillsActionTaken: '',
    jackhammerInServerRoom: {
      value: YesNoFormValue.YES,
      comment: ''
    },
    jackhammerInCabinetByClinkerBreaker: {
      value: YesNoFormValue.YES,
      comment: ''
    }
  }
